export class MarketplaceCategoryTranslation {
    id: number;
    locale: string;
    name: string;

    /**
     * constructor
     *
     * @param {MarketplaceCategoryTranslation} init
     */
    public constructor(init?: MarketplaceCategoryTranslation) {
        if (!!init) {
            Object.assign(this, init);
        }
    }

}
